import { render, staticRenderFns } from "./breadcrump.vue?vue&type=template&id=31b6a7de"
import script from "./breadcrump.vue?vue&type=script&lang=js"
export * from "./breadcrump.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports